// src/components/dashboard/cases/newCase/case_id/shipmentLabel.js
// OPTIMIZED: caseData prop se URLs leta hai, sirf PUT pe API hit

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTimes } from '@fortawesome/free-solid-svg-icons';

const ShipmentLabel = ({ caseId, caseData, onUpdate }) => {
  const [shipmentTrackingUrl, setShipmentTrackingUrl] = useState('');
  const [isEditingUrl, setIsEditingUrl] = useState(false);
  const [urls, setUrls] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const API_BASE_URL = 'https://hms.backend.hiragroupcloud.com/api/cases';

  // Sync URLs from caseData
  useEffect(() => {
    if (caseData?.shipmentTrackingUrls) {
      setUrls(caseData.shipmentTrackingUrls || []);
    } else {
      setUrls([]);
    }
  }, [caseData?.shipmentTrackingUrls]);

  const handleIconClick = () => {
    setIsEditingUrl(!isEditingUrl);
    if (!isEditingUrl) setShipmentTrackingUrl('');
  };

  const handleInputChange = (e) => setShipmentTrackingUrl(e.target.value);

  const saveUrl = async () => {
    const urlToNavigate = shipmentTrackingUrl.trim();
    if (!urlToNavigate) return;

    setIsLoading(true);
    setError(null);
    try {
      await axios.put(`${API_BASE_URL}/${caseId}/shipment`, { url: urlToNavigate });
      const newUrls = [...urls, urlToNavigate];
      setUrls(newUrls);
      if (onUpdate) onUpdate({ shipmentTrackingUrls: newUrls });
      setShipmentTrackingUrl('');
      setIsEditingUrl(false);
    } catch (error) {
      setError(error.response?.data?.message || "Failed to save shipment URL");
      console.error("❌ Error saving shipment URL:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const removeUrl = async (urlToRemove) => {
    setIsLoading(true);
    setError(null);
    try {
      await axios.put(`${API_BASE_URL}/${caseId}/shipment/remove`, { url: urlToRemove });
      const newUrls = urls.filter(url => url !== urlToRemove);
      setUrls(newUrls);
      if (onUpdate) onUpdate({ shipmentTrackingUrls: newUrls });
    } catch (error) {
      setError(error.response?.data?.message || "Failed to remove shipment URL");
      console.error("❌ Error removing shipment URL:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setShipmentTrackingUrl('');
    setIsEditingUrl(false);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1%' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Shipment Tracking:</label>
        <button
          onClick={handleIconClick}
          style={{
            cursor: 'pointer', backgroundColor: 'transparent', color: '#004aad',
            padding: '0', border: 'none', outline: 'none', boxShadow: 'none',
            borderRadius: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
          disabled={isLoading}
        >
          <FontAwesomeIcon icon={faPen} style={{ fontSize: '15px' }} />
        </button>
      </div>

      {error && <div style={{ color: 'red', margin: '10px 0' }}>{error}</div>}
      {isLoading && <div style={{ margin: '10px 0' }}>Saving...</div>}

      {isEditingUrl && (
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
          <input
            type="text"
            placeholder="Enter tracking URL"
            style={{ width: '200px', padding: '5px', border: '1px solid #ccc', marginRight: '10px' }}
            value={shipmentTrackingUrl}
            onChange={handleInputChange}
            disabled={isLoading}
          />
          <button
            onClick={saveUrl}
            style={{
              marginLeft: '10px', cursor: 'pointer', backgroundColor: '#004aad',
              color: 'white', padding: '5px 8px', borderRadius: '4px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              borderColor: '#004aad',
            }}
            disabled={isLoading}
          >
            Save
          </button>
          <button
            onClick={handleCancel}
            style={{
              marginLeft: '10px', cursor: 'pointer', backgroundColor: '#004aad',
              color: 'white', padding: '5px 8px', borderRadius: '4px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              borderColor: '#004aad',
            }}
            disabled={isLoading}
          >
            Cancel
          </button>
        </div>
      )}

      <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
        {urls.map((url, index) => (
          <div
            key={index}
            style={{
              display: 'flex', alignItems: 'center', backgroundColor: '#e0e0e0',
              padding: '3px 8px', borderRadius: '15px', maxWidth: '100%',
            }}
          >
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: 'none', color: '#004aad', fontWeight: '500',
                overflow: 'hidden', textOverflow: 'ellipsis',
                whiteSpace: 'nowrap', maxWidth: '200px', marginRight: '5px',
              }}
              title={url}
            >
              {url}
            </a>
            <button
              onClick={() => removeUrl(url)}
              style={{
                backgroundColor: 'transparent', color: '#f44336', border: 'none',
                marginLeft: '5px', cursor: 'pointer', padding: '0', fontSize: '12px',
              }}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShipmentLabel;